import {NgModule} from '@angular/core';
import {AppInterceptor} from './config/app.interceptor';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {LanguageService} from "./shared/services/language.service";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {MessageService} from 'primeng/api';
import {LoaderInterceptor} from './interceptor/loader.interceptor';
import {CookieService} from 'ngx-cookie-service';
import {AuthTokenService} from './shared/services/token.service';

import {BsModalService} from 'ngx-bootstrap/modal';
import {MainLandingComponent} from "./pages/landing/components/main-landing/main-landing.component";
import {
  TenantConfigurationComponent
} from "./pages/landing/components/tenant-configuration/tenant-configuration.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LayoutModule} from "./shared/modules/layout.module";
import {LoaderComponent} from "./shared/components/loader/loader.component";
import {GoogleMapsModule} from '@angular/google-maps'
import {SharedModule} from "./shared/modules/shared.module";
import {PagenotfoundComponent} from "./pagenotfound/pagenotfound.component";
import {MaintenanceComponent} from "./pages/maintenance/maintenance.component";
import {ErrorInterceptor} from "./interceptor/error.interceptor";
import {NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule} from "ngx-google-analytics";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    MaintenanceComponent,
    MainLandingComponent,
    TenantConfigurationComponent,
    LoaderComponent,PagenotfoundComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      defaultLanguage: 'en'
    }),
    GoogleMapsModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    NgxGoogleAnalyticsModule.forRoot('G-9PG5BVT6XN'),
    NgxGoogleAnalyticsRouterModule
  ],
  providers: [
    BsModalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    LanguageService,
    MessageService,
    CookieService,
    AuthTokenService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
